var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChatBlack = function SvgChatBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9025 5.08333C10.3735 5.08333 4.27002 11.1868 4.27002 18.7158C4.27002 26.0876 10.1212 32.0927 17.4326 32.3403V41.2798L26.3642 32.3483H27.3042C34.8332 32.3483 40.9367 26.2448 40.9367 18.7158C40.9367 11.1868 34.8332 5.08333 27.3042 5.08333H17.9025Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4326 32.3403H18.4326V31.3736L17.4665 31.3409L17.4326 32.3403ZM17.4326 41.2798H16.4326V43.694L18.1397 41.9869L17.4326 41.2798ZM26.3642 32.3483V31.3483H25.95L25.6571 31.6412L26.3642 32.3483ZM5.27002 18.7158C5.27002 11.7391 10.9258 6.08333 17.9025 6.08333V4.08333C9.8212 4.08333 3.27002 10.6345 3.27002 18.7158H5.27002ZM17.4665 31.3409C10.692 31.1115 5.27002 25.5466 5.27002 18.7158H3.27002C3.27002 26.6285 9.55038 33.0739 17.3988 33.3398L17.4665 31.3409ZM18.4326 41.2798V32.3403H16.4326V41.2798H18.4326ZM25.6571 31.6412L16.7255 40.5727L18.1397 41.9869L27.0713 33.0554L25.6571 31.6412ZM27.3042 31.3483H26.3642V33.3483H27.3042V31.3483ZM39.9367 18.7158C39.9367 25.6925 34.2809 31.3483 27.3042 31.3483V33.3483C35.3855 33.3483 41.9367 26.7971 41.9367 18.7158H39.9367ZM27.3042 6.08333C34.2809 6.08333 39.9367 11.7391 39.9367 18.7158H41.9367C41.9367 10.6345 35.3855 4.08333 27.3042 4.08333V6.08333ZM17.9025 6.08333H27.3042V4.08333H17.9025V6.08333Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.6001,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FF7126"
  })));
};

export default SvgChatBlack;